import { useAuth } from "@/lib/auth";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { canSee, landing } from "@/lib/access";

export default function ProtectedRoute({ children, roles, areas }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen bg-[#FAF8F5] flex items-center justify-center">
        <Loader2 className="h-8 w-8 text-amber-800 animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  if ((roles && !roles.includes(user.role)) || (areas && user.role === "staff" && !canSee(user, ...areas))) {
    const to = landing(user);
    return to === loc.pathname ? <Navigate to="/dashboard" replace /> : <Navigate to={to} replace />;
  }
  return children;
}
